<!-- 
Dashboard widget showing warnings and flags for levy collection providers in the levy collection.
-->
<template>
  <v-flex xs12 md6 lg4 xl3>
    <v-card flat class="home">
      <our-widget-toolbar title="Provider warnings and flags" @refresh="forceReload" @remove="removeWidget" />
      <our-busy-indicator :show="!loaded"/>
      <div style="overflow-y: auto; height: 297px;">
        <v-card-text class="pt-1 pb-3 px-0">
          <our-chart-is-empty-placeholder v-if="empty" style="height: 265px" />
          <v-list v-else>
            <warnings-and-flags-widget-expanders 
              :levy-collection-id="levyCollectionId" 
              :warnings="warnings"
            />
            <warnings-and-flags-widget-expanders 
              :levy-collection-id="levyCollectionId" 
              :warnings="information"
              informational
            />
          </v-list>
        </v-card-text>
      </div>
    </v-card>
  </v-flex>
</template>

<script>
import _ from "underscore";
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";
import taskMixins from "@/mixins/task.mixins";
import WarningsAndFlagsWidgetExpanders from "./WarningsAndFlagsWidgetExpanders.vue";
import * as lcpAction from "@/store/levy-collection-providers/action-types";

export default {
  components: { WarningsAndFlagsWidgetExpanders },
  mixins: [lookupMixins, taskMixins, filterMixins],
  props: {
    levyCollectionId: {
      type: Number,
      required: true
    }
  },
  computed: {
    state() {
      return this.$store.state.levyCollectionProviders.warnings;
    },
    warnings() {
      return _(this.state.data).filter(d => d.count > 0 && !this.isForInformationOnly(d.type));
    },
    information() {
      return _(this.state.data).filter(d => d.count > 0 && this.isForInformationOnly(d.type));
    },
    loaded() {
      return this.state.loaded;
    },
    empty() {
      return this.warnings.length == 0 && this.information.length == 0;
    }
  },
  watch: {
    levyCollectionId() {
      this.refresh();
    },
    loaded() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.dispatch(lcpAction.WARNINGS_REFRESH, this.levyCollectionId);
    },
    forceReload() {
      this.$store.dispatch(lcpAction.WARNINGS_GET, this.levyCollectionId);
    },
    removeWidget() {
      this.$emit("removeWidget");
    },
    isForInformationOnly(warningType) {
      return this.doesLookupHaveAttribute(
        warningType,
        "ForInformationOnly",
        this.lookups.levyCollectionProviderWarningTypes
      );
    }
  }
};
</script>

<style lang="scss">
.run-tip {
  font-size: 11px !important;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 2px 5px;
  border: none;
  border-radius: 3px 0px 3px 0px;
}
</style>